<template>
<div id="bill_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <!-- <div v-if="poInvoiceFromWO && poInvoiceFromWO != undefined">
        PO Invoice From WO
        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="BillForm">
            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                <div class="col form-group verification-section-main">
                    <label class="control-label">File:</label>
                    <div class="custom-upload-container" data-provides="fileupload">
                        <label for="physicalFiles" class="fileupload-new btn btn-secondary" v-if="!isUpdate"><i class="fp-upload"></i>Upload</label>
                        <label for="physicalFiles" class="fileupload-exists btn btn-secondary" v-if="isUpdate"><i class="fp-upload"></i>Change</label>
                        <input class="hide" type="file" id="physicalFiles" ref="files" v-on:change="handleFilesUpload()"/>
                        <div class="field-error">{{fileerror_msg}}</div>
                    </div>
                    <template v-if="!isUpdate">
                        <template v-for="(file, key) in filesArr">
                            <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">
                                <span class="fileupload-preview">{{ file.name }}</span>
                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">
                                    <i class="fp-delete"></i>
                                </a>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <template  v-for="(files, key1) in existFilesArr">
                            <div v-bind:key="key1" class="file-container">
                                <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(files.url,files.ext)">{{ files.display_name }}</a>
                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteBillFile(key1,files.path)" style="float: right">
                                    <i class="fp-delete"></i>
                                </a>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="col form-group">
                </div>
            </div>
            <div class="form-row row-cols-md-4 row-cols-1">
                <div class="col form-group">
                    <label class="control-label require" for="vendor_id">Vendor:</label>
                    <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor Code or Name" class="custom-ci-auto-search" @input="onVendorChange()">
                        <template slot="no-options">
                            Search Vendor Code or Name...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{ vendor_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="period">Assignee:</label>
                    <input type="text" class="form-control" v-model="assignee" id="assignee" placeholder="Enter Assignee" name="assignee">
                    <div class="field-error">{{assignee_error}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="period">#Invoice:</label>
                    <input type="text" class="form-control" v-model="bill_number" id="bill_number" placeholder="Enter Invoice Number" name="bill_number">
                    <div class="field-error">{{bill_error}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="reference">Reference Number:</label>
                    <input type="text" class="form-control" v-model="reference" id="reference_number" placeholder="Enter Reference Number" name="reference_number">
                    <div class="field-error"></div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="bill_date">Invoice Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                        <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ bill_date_error_msg }}</div>
                </div>
                <div class=" col form-group">
                    <label class="control-label" for="due_date">Due Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate"></date-picker>
                        <label for="due_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ due_date_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="po">PO:</label>
                    <v-select v-model="po" name="po"
                            label="text" :filterable="false" :options="purchaseOrderArr"
                            @search="onSearchPurchaseOrder"
                            placeholder="Select PO" class="custom-ci-auto-search" @input="onPOSelect($event)">
                        <template slot="no-options">
                            Search PO...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{ po_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="state">Location:</label>
                    <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr">
                    </v-select>
                    <div class="field-error">{{location_error_msg}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="period">Notes:</label>
                    <textarea class="form-control" v-model="notes" id="attention" placeholder="Enter Notes" name="Notes">
                    </textarea>
                    <div class="field-error">{{notes_error_msg}}</div>
                </div>
            </div>
            <div class="purchase-order-create-main table-responsive-sm">
                <table aria-describedby="table" id="vendor-invoice-line-items-tbl" class="table table-sm table-bordered font-1">
                    <thead>
                        <tr class="table-primary">
                            <th scope="col" style="width:250px" class="require">Description</th>
                            <th scope="col" style="width:100px" class="require">Quantity</th>
                            <th scope="col" style="width:100px" class="require">Labor Amount</th>
                            <th scope="col" style="width:100px" class="require">Material Amount</th>
                            <th scope="col" style="width:100px" class="require">Amount</th>
                            <th scope="col" style="width:50px"> Action </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in rows" :key="index">
                            <td>
                                <textarea v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                </textarea>
                                <div class="field-error">{{row.desc_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity" @keypress="isNumberCheck($event)" v-on:keyup="calculateSubletInvoice($event,index)" id="quantity" class="form-control text-right" disabled>
                                <div class="field-error">{{row.quantity_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Labor" v-model="row.labor" v-on:keyup="calculateSubletInvoice($event,index)" @keypress="isNumberCheck($event)" name="row.labor" class="form-control text-right">
                                <div class="field-error">{{row.labor_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Materials" v-model="row.materials" v-on:keyup="calculateSubletInvoice($event,index)" @keypress="isNumberCheck($event)" name="row.materials" class="form-control text-right">
                                <div class="field-error">{{row.materials_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Amount"  v-model="row.amount" v-on:keyup="calculateSubletInvoice($event,index)" @keypress="isNumberCheck($event)" id="amount" name="amount" class="form-control text-right">
                                <div class="field-error">{{row.amount_error_msg}}</div>
                            </td>
                            <td class="text-center valign-middle">
                                <template v-if="rows.length > 1">
                                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeElement(index);"> ×
                                        </a></span>
                                </template>
                                <template v-else>
                                    <span class="close-row"> _ </span>
                                </template>
                            </td>
                        </tr>    
                    </tbody>
                </table>        
            </div>
            <hr class="light-hr"/>
            <div class="purchase-order-create-main table-responsive-sm">
                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                    <thead>
                        <tr class="table-primary">
                            <th scope="col" class="require" style="width:400px">Charge Type</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Price</th>
                            <th scope="col">Amount</th>
                            <th scope="col"> Action </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                            <td>
                                <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                            label="text"
                                            :options="chargesArr" @input="onChargeSelect($event,chindex)">
                                </v-select>
                                <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Quantity" v-model="chrow.quantity" name="quantity" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberCheck($event)" id="quantity" class="form-control text-right">
                                <div class="field-error">{{chrow.quantity_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" placeholder="Price" v-model="chrow.unit_price" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberCheck($event)" name="row.unit_price" class="form-control text-right">
                                <div class="field-error">{{chrow.unit_price_error_msg}}</div>
                            </td>
                            <td>
                                <input type="text" disabled placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right">
                            </td>
                            <td class="text-center valign-middle">
                                <template v-if="chrows.length != 1">
                                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                        </a></span>
                                </template>
                                <template v-else>
                                    <span class="close-row"> _ </span>
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="btn-groups mt-2">
                <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                    <i class="fp-add"></i> Add Charge
                </button>
            </div> -->
            <!-- <div class="order-summary mt-4"> Description section -->
                <!-- <div class="row">
                    <div class="col-md-6 offset-md-6">
                        <div class="bg-white radius-5 p-3">
                            <label class="font-bold"> SUMMARY </label>
                            <table aria-describedby="table" class="table table-sm table-bordered">
                                <tr class="table-secondary">
                                    <td> Subtotal: </td>
                                    <td class="text-right"> ${{sub_total.toFixed(2)}} </td>
                                </tr>
                                <tr>
                                    <td> Tax Amount: </td>
                                    <td class="text-right"> ${{total_tax.toFixed(2)}} </td>
                                </tr>
                                <tr class="table-secondary">
                                    <td> Discount: </td>
                                    <td class="text-right"> ${{totalDiscount.toFixed(2)}} </td>
                                </tr>
                                <tr>
                                    <td> Total: </td>
                                    <td class="order-total text-right"> {{amountFormat(total)}} </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="alert alert-warning hide col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                </div>
            </div>
            <div class="btn-groups">
                <button type="submit" id="CreateBillBtn" class="btn btn-primary" v-on:click.prevent="CreateBill">
                    <i class="fp-save"> </i> Save
                </button>
                <button type="submit" id="cancelBillBtn" class="btn btn-tertiary" v-on:click.prevent="BackBillList">
                    <i class="fp-close"> </i> Cancel
                </button>
            </div>    
        </form>    
    </div>     -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="BillHeader" v-if="$route.params.id > 0">Update Vendor Invoice</span>
                <span class="page-title" id="BillHeader" v-else>Add Vendor Invoice</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BillList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content vendor-invoice-crud">
                    <section class="internal-container border-top-table-fl">
                        <!-- <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="BillForm"> -->
                            <!-- <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                                <div class="col form-group verification-section-main">
                                    <label class="control-label">File:</label>
                                    <div class="custom-upload-container" data-provides="fileupload">
                                        <label for="physicalFiles" class="fileupload-new btn btn-secondary" v-if="!isUpdate"><i class="fp-upload"></i>Upload</label>
                                        <label for="physicalFiles" class="fileupload-exists btn btn-secondary" v-if="isUpdate"><i class="fp-upload"></i>Change</label>
                                        <input class="hide" type="file" id="physicalFiles" ref="files" v-on:change="handleFilesUpload()"/>
                                        <div class="field-error">{{fileerror_msg}}</div>
                                    </div>
                                    <template v-if="!isUpdate">
                                        <template v-for="(file, key) in filesArr">
                                            <div v-bind:key="key" class="file-container" :id="'fileDiv'+file.id">
                                                <span class="fileupload-preview">{{ file.name }}</span>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteDoc(file.id,key)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template  v-for="(files, key1) in existFilesArr">
                                            <div v-bind:key="key1" class="file-container">
                                                <a href="javascript:void(0)" class="fileupload-preview" v-on:click="openDocument(files.url,files.ext)">{{ files.display_name }}</a>
                                                <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteBillFile(key1,files.path)" style="float: right">
                                                    <i class="fp-delete"></i>
                                                </a>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <div class="col form-group" v-if="$route.params.id != undefined">
                                    <label class="control-label" for="voucher">Voucher Number: </label>
                                    <span class="label">{{voucher}}</span>
                                </div>
                            </div> -->
                            <!-- <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="vendor_id">Vendor:</label>
                                    <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor Code or Name" class="custom-ci-auto-search" @input="onVendorChange()">
                                        <template slot="no-options">
                                            Search Vendor Code or Name...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ vendor_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="period">Assignee:</label>
                                    <input type="text" class="form-control" v-model="assignee" id="assignee" placeholder="Enter Assignee" name="assignee">
                                    <div class="field-error">{{assignee_error}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="period">#Invoice:</label>
                                    <input type="text" class="form-control" v-model="bill_number" id="bill_number" placeholder="Enter Invoice Number" name="bill_number">
                                    <div class="field-error">{{bill_error}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="reference">Reference Number:</label>
                                    <input type="text" class="form-control" v-model="reference" id="reference_number" placeholder="Enter Reference Number" name="reference_number">
                                    <div class="field-error"></div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="bill_date">Invoice Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                                        <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ bill_date_error_msg }}</div>
                                </div>
                                <div class=" col form-group">
                                    <label class="control-label" for="due_date">Due Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate"></date-picker>
                                        <label for="due_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ due_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="po">PO:</label>
                                    <v-select v-model="po" name="po"
                                            label="text" :filterable="false" :options="purchaseOrderArr"
                                            @search="onSearchPurchaseOrder"
                                            placeholder="Select PO" class="custom-ci-auto-search" @input="onPOSelect($event)">
                                        <template slot="no-options">
                                            Search PO...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ po_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="state">Location:</label>
                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{location_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="period">Notes:</label>
                                    <textarea class="form-control" v-model="notes" id="attention" placeholder="Enter Notes" name="Notes">
                                    </textarea>
                                    <div class="field-error">{{notes_error_msg}}</div>
                                </div>
                            </div>  -->
                            <!-- <div class="purchase-order-create-main table-responsive-sm">
                                <div class="selection-info-row">
                                    <a href="javascript:void(0);" class="color-blue show-more-invoice-items" v-on:click="showMoreLessContent()">{{showMoreLessLabel}}</a>
                                </div>
                                <table aria-describedby="table" id="vendor-invoice-line-items-tbl" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary"> -->
                                            <!-- <th scope="col" style="width:250px" class="require">Description</th> -->
                                            <!-- <template v-if="vendor_inv_type == 'item'">
                                                <th scope="col" v-show="showMoreLessFlag" style="width:200px" class="require">Part</th>
                                            </template>
                                            <template v-else-if="vendor_inv_type == 'sublet_po'">
                                                <th scope="col" style="width:250px" class="require">Description</th>
                                                <th scope="col" v-show="showMoreLessFlag" style="width:200px" class="require">Part</th>
                                            </template>
                                            <template v-else>
                                                <th scope="col" v-show="showMoreLessFlag" style="width:200px" class="require">Part</th>
                                                <th scope="col" style="width:250px" class="require">Description</th>
                                            </template> -->
                                            <!-- <th scope="col" class="require" style="width:200px">GL Account</th> -->
                                            <!-- <th scope="col" style="width:100px" class="require">Qty/Hrs</th>
                                            <th scope="col" style="width:100px" class="require">Unit Price</th>
                                            <th scope="col" v-show="showMoreLessFlag" style="width:100px">Tax</th>
                                            <th scope="col" style="width:100px" class="require">Amount</th>
                                            <th scope="col" style="width:50px"> Action </th>
                                        </tr>
                                    </thead> -->
                                    <!-- <tbody>
                                        <tr v-for="(row, index) in rows" :key="index"> -->
                                            <!-- <td>
                                                <textarea v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                                </textarea>
                                                <div class="field-error">{{row.desc_error_msg}}</div>
                                            </td> -->
                                            <!-- <td v-show="showMoreLessFlag">
                                                <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                    <template slot="no-options">
                                                        Search Part...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="field-error">{{row.part_error_msg}}</div>
                                            </td>
                                            <td>
                                                <textarea v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                                </textarea>
                                                <div class="field-error">{{row.desc_error_msg}}</div>
                                            </td> -->
                                            <!-- <template v-if="vendor_inv_type == 'item'">
                                                <td v-show="showMoreLessFlag">
                                                    <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search Part...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.part_error_msg}}</div>
                                                </td>
                                            </template> -->
                                            <!-- <template v-else-if="vendor_inv_type == 'sublet_po'">
                                                <td>
                                                    <textarea v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                                    </textarea>
                                                    <div class="field-error">{{row.desc_error_msg}}</div>
                                                </td>
                                                <td v-show="showMoreLessFlag">
                                                    <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search Part...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.part_error_msg}}</div>
                                                </td>    
                                            </template> -->
                                            <!-- <template v-else>
                                                <td v-show="showMoreLessFlag">
                                                    <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                            Search Part...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.part_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <textarea v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                                    </textarea>
                                                    <div class="field-error">{{row.desc_error_msg}}</div>
                                                </td>
                                            </template> -->
                                            <!-- <td>
                                                <v-select v-model="row.gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                    <template slot="no-options">
                                                        Search GL Account...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="field-error gl-account-error">{{row.gl_account_error_msg}}</div>
                                            </td> -->
                                            <!-- <td>
                                                <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity" @keypress="isNumberCheck($event)" v-on:keyup="calculateAmount($event,index)" id="quantity" class="form-control text-right">
                                                <div class="field-error">{{row.quantity_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Price" v-model="row.unit_price" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" name="row.unit_price" class="form-control text-right">
                                                <div class="field-error">{{row.unit_price_error_msg}}</div>
                                            </td>
                                            <td v-show="showMoreLessFlag">
                                                <v-select v-model="row.tax_id" name="tax_id" placeholder="Select Tax." label="text" :options="taxesArr" @input="onTaxSelect($event,index)" :disabled="row.enableTaxSelect">
                                                </v-select>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Amount"  v-model="row.amount" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" id="amount" name="amount" class="form-control text-right">
                                                <div class="field-error">{{row.amount_error_msg}}</div>
                                            </td>
                                            <td class="text-center valign-middle">
                                                <template v-if="rows.length > 1">
                                                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeElement(index);"> ×
                                                        </a></span>
                                                </template>
                                                <template v-else>
                                                    <span class="close-row"> _ </span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> -->
                            <!-- <div class="btn-groups">
                                <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                    <i class="fp-add"></i>Add Line Item
                                </button>
                            </div>
                            <hr class="light-hr"/> -->
                            <!-- <h5 class="color-blue font-bold mt-3">Discount</h5>
                            <div class="purchase-order-create-main table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col" class="require">Description</th>
                                            <th scope="col" class="require" style="width:400px">GL Account</th>
                                            <th scope="col" class="require">Amount</th>
                                            <th scope="col" class=""> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(disrow, disindex) in disrows" :key="disindex">
                                            <td>
                                                <textarea v-model="disrow.description" name="disdescription" placeholder="Description" class="form-control">
                                                </textarea>
                                                <div class="field-error">{{disrow.description_error_msg}}</div>
                                            </td>
                                            <td>
                                                <v-select v-model="disrow.gl_account_id" name="dis_gl_account_id" id="dis_gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                                    <template slot="no-options">
                                                        Search GL Account...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="field-error">{{disrow.gl_account_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Amount"  v-model="disrow.discount" v-on:keyup="calculateDiscount($event,disindex)" @keypress="isNumberCheck($event)" id="discount" name="discount" class="form-control pull-left text-right">
                                                <div class="field-error">{{disrow.discount_error_msg}}</div>
                                            </td>
                                            <td class="text-center valign-middle">
                                                <template v-if="disrows.length > 1">
                                                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeDiscountElement(disindex);"> ×
                                                        </a></span>
                                                </template>
                                                <template v-else>
                                                    <span class="close-row"> _ </span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-on:click.prevent="addDiscountRow()" class="btn btn-primary">
                                    <i class="fp-add"></i>Discount Item
                                </button>
                            </div>
                            <hr class="light-hr"/> -->
                            <!-- <div class="purchase-order-create-main table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col" class="require" style="width:400px">Charge Type</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Price</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col"> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                            <td>
                                                <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                                            label="text"
                                                            :options="chargesArr" @input="onChargeSelect($event,chindex)">
                                                </v-select>
                                                <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Quantity" v-model="chrow.quantity" name="quantity" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberCheck($event)" id="quantity" class="form-control text-right">
                                                <div class="field-error">{{chrow.quantity_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" placeholder="Price" v-model="chrow.unit_price" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberCheck($event)" name="row.unit_price" class="form-control text-right">
                                                <div class="field-error">{{chrow.unit_price_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" disabled placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right">
                                            </td>
                                            <td class="text-center valign-middle">
                                                <template v-if="chrows.length != 1">
                                                    <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                                        </a></span>
                                                </template>
                                                <template v-else>
                                                    <span class="close-row"> _ </span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                                    <i class="fp-add"></i> Add Charge
                                </button>
                            </div> -->
                            <!-- <div class="order-summary mt-4" v-if="showTotalSummary"> Description section -->
                                <!-- <div class="row">
                                    <div class="col-md-6 offset-md-6">
                                        <div class="bg-white radius-5 p-3">
                                            <label class="font-bold"> SUMMARY </label>
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <tr class="table-secondary">
                                                    <td> Subtotal: </td>
                                                    <td class="text-right"> ${{sub_total.toFixed(2)}} </td>
                                                </tr>
                                                <tr>
                                                    <td> Tax Amount: </td>
                                                    <td class="text-right"> ${{total_tax.toFixed(2)}} </td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td> Discount: </td>
                                                    <td class="text-right"> ${{totalDiscount.toFixed(2)}} </td>
                                                </tr>
                                                <tr>
                                                    <td> Total: </td>
                                                    <td class="order-total text-right"> {{amountFormat(total)}} </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div> -->
                            <!-- </div> Description section -->
                            <!-- <div class="form-group">
                                <div class="alert alert-warning hide col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-if="$route.params.id > 0" id="CreateBillBtn" class="btn btn-primary" v-on:click.prevent="CreateBill">
                                    <i class="fp-reload"> </i> Update
                                </button>
                                <button type="submit" v-else id="CreateBillBtn" class="btn btn-primary" v-on:click.prevent="CreateBill">
                                    <i class="fp-save"> </i> Save
                                </button>
                                <button type="submit" v-if="$route.params.id == undefined" id="createAndContinueBillBtn" class="btn btn-tertiary" v-on:click.prevent="CreateBill(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i> Save and Continue
                                </button>
                                <button type="submit" id="cancelBillBtn" class="btn btn-tertiary" v-on:click.prevent="BackBillList">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                            <div class="modal fade error-message-modal" id="error-message-modal" ref="errorMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="errorMessageModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Message</h5>
                                            <button type="button" class="close" id="btnModalClose" v-on:click.prevent="hideMessageModal()">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <p class="field-error">Following fields does not match with uploaded invoice:.</p>
                                            <template v-if="matchingValuesError.length">
                                                <template v-for="(errorField,key) in matchingValuesError">
                                                    <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{errorField}}</span>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="btnModalok" v-on:click.prevent="submitBill()"> Ok </button>
                                            <button class="btn btn-tertiary" id="btnModalCancel" v-on:click.prevent="hideMessageModal()"> Close </button>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        <!-- </form> -->
                        <vendor-invoice-form id="vendor-invoice-form"></vendor-invoice-form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import VendorInvoiceForm from '@/components/accounting/VendorInvoiceForm.vue';

Vue.component("vendor-invoice-form", VendorInvoiceForm);

import moment from 'moment';

export default {
    name: "BillCreate",
    // metaInfo() {
    //     return {
    //         title: (this.$route.params.id > 0)? "Update Vendor Invoice | " +process.env.COPYRIGHT_NAME : "Create Vendor Invoice | " +process.env.COPYRIGHT_NAME
    //     }
    // },
    
    mixins: [commonMixins, contractMixins],
    props: {
        poInvoiceFromWO: {
            type: String,
            required: false,
            default:undefined
        },
        poDataFromWO: {
            type: Object,
            required: false,
            default:undefined
        },
    },
    data: () => ({
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        bill_number: "",
        bill_error:'',
        vendor_id: null,
        vendorArr: [],
        status: "open",
        open_status: "open",
        closed_status: "closed",
        reserved__status: "reserved",
        openCheckBox: "1",
        closedCheckBox: "1",
        reservedCheckBox: "1",
        loading: false,
        showCharges: false,
        type: "",
        reference:'',
        status_error_msg: "",
        type_error_msg: "",
        amount_error_msg: "",
        tax_percentage_error_msg: "",
        total_charge_error_msg: "",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        rows: [],
        sub_total: 0,
        total: 0,
        notes: "",
        userArr: [],
        customer_id: null,
        customer_error_msg: "",
        bill_date: "",
        due_date: "",
        bill_date_error_msg: "",
        due_date_error_msg: "",
        componentArr: [],
        vendor_error_msg: "",
        amount:'',
        tax:0,
        total_tax:0,
        wo_amount_error_msg:'',
        notes_error_msg:'',
        filesArr:[],
        existFilesArr:[],
        bill_id:'',
        purchaseOrderArr:[],
        po:'',
        location_id:"",
        locationArr:[],
        location_error_msg:"",
        taxesArr:[],
        disableStatusField:false,
        po_error_msg:"",
        showTotalSummary:false,
        voucher:'',
        fileerror_msg:'',
        accountsArr:[],
        isPORequired:false,
        poRequiredClass:'',
        isUpdate:false,
        pdfArr:[],
        matchingValuesError:[],
        valuesFound:false,
        assignee:'',
        assignee_error:'',
        disrows:[],
        totalDiscount:0,
        pre_subtotal : 0,
        showMoreLessLabel:"Show More",
        showMoreLessFlag:false,
        pageDescription:"Vendor Invoice Create | " +process.env.COPYRIGHT_NAME,
        watchCall:false,
        accountCanChanged:false,
        chrows:[],
        chargesArr:[],
        vendor_inv_type:"",
        poId:'',
        redirectFrom:'',
        receipt_id: "",
    }),
    metaInfo () {
        if (this.poInvoiceFromWO == undefined) {
            return {
                title: (this.$route.params.id > 0)? "Update Vendor Invoice | " +process.env.COPYRIGHT_NAME : "Create Vendor Invoice | " +process.env.COPYRIGHT_NAME
            }
        }
    },
    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_vendor_invoice') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        sub_total: function () {
            var self = this;
            self.total = (self.total_tax + self.sub_total).toFixed(2);
            if (self.totalDiscount > 0) {
                self.total = self.total - self.totalDiscount;
                self.showTotalSummary = true;
            }

        },
        total_tax: function () {
            var self = this;
            self.total = (self.total_tax + self.sub_total).toFixed(2);
            if (self.totalDiscount > 0) {
                self.total = self.total - self.totalDiscount;
            }
        },
        bill_date: function (newVal,oldVal) {
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.watchCall) {
                return;
            }else{
                if (self.vendor_id != null && self.vendor_id.term ){
                    var date = '';
                    if(self.vendor_id.term_period == 'month'){
                        date = moment(newVal, "MM/DD/YYYY")
                                .add(self.vendor_id.term,'month') //replace 2 with number of days you want to add

                    }else{

                        date = moment(newVal, "MM/DD/YYYY")
                                .add(self.vendor_id.term,'days')
                    }

                    self.due_date = date;

                }
            }
        },
        showCharges() {
            var self = this;
            if (self.showCharges) {
                //self.getPurchaseOrderChargesData();
            }
        },

        location_id:function(val){

            var self = this;
             if (self.$route.params.id != undefined && self.accountCanChanged == false){
                return;
            }
            if (val.value != undefined){
                if (self.rows.length > 1){
                    for(var i=0;i < self.rows.length; i++){
                        self.rows[i].gl_account_id = '';
                    }
                }
            }
        },
        //get parse content of file
        filesArr: function (files) {

            var self = this;

            if ( files.length > 0 && files[0].type == 'application/pdf' ) {

                const fields = new FormData();

                for (var i = 0; i < self.filesArr.length; i++) {
                    let file = this.filesArr[i];
                    fields.append("files[]", file);
                }

                $.ajax({
                    url: process.env.ROOT_API + "/bill/parse-file",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.pdfArr = data.content;
                            console.log(self.pdfArr);
                            if (self.pdfArr.invDate != undefined && self.pdfArr.invDate != null && self.pdfArr.invDate != "" ) {
                                self.valuesFound = true;
                                if ( self.pdfArr.loadDetail ) {
                                    if (self.bill_date == "" || self.bill_date == null) {
                                        self.bill_date = moment(self.pdfArr.invDate,"MM/DD/YYYY");
                                    }
                                }
                            }
                            if (self.pdfArr.invDueDate != undefined && self.pdfArr.invDueDate != null && self.pdfArr.invDueDate != "" ) {
                                self.valuesFound = true;
                                if ( self.pdfArr.loadDetail ) {
                                    if (self.due_date == "" || self.due_date == null) {
                                        self.due_date = moment(self.pdfArr.invDueDate,"MM/DD/YYYY");
                                    }
                                }
                            }
                            if (self.pdfArr.invNo != undefined && self.pdfArr.invNo != null && self.pdfArr.invNo != "" ) {
                                self.valuesFound = true;
                                if ( self.pdfArr.loadDetail ) {
                                    if (self.bill_number == "" || self.bill_number == null) {
                                        self.bill_number = self.pdfArr.invNo;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-parse-file');
                    }
                });
            }
        }

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // console.log("Vendor PO from WO Load");
        // console.log(self.poInvoiceFromWO);
        // console.log(self.poDataFromWO);
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        // var userObj = JSON.parse(localStorage.getItem("user_obj"));
        // if (userObj != null) {
        //     // var userJson = JSON.parse(userObj);
        //     if (userObj.roles.length > 0) {
        //         self.role = userObj.roles[0].name;

        //     }

        //     //set LoggedIn user's location as default location....
        //     if (userObj["location_id"] != null && userObj["location_id"] != '') {
        //         if ( userObj["locationName"] != undefined && userObj["locationCode"] != undefined ) {
        //             self.location_id = {
        //                 value: userObj["location_id"],
        //                 text: self.titleCase(userObj["locationName"]) + " | " + userObj["locationCode"]
        //             };
        //         }
        //     }
        // }


        self.getPermissions();

        // self.loadFieldData(['taxes','location','charges']);
        //from work order view page
        // if (self.poInvoiceFromWO != undefined) {
        //     console.log("MOUNTED IF ");
        //     self.vendor_inv_type = "sublet_invoice";
        //     self.rows = [];
        //     self.chrows = [];

        //     self.rows.push({
        //         bill_item_id:0,
        //         quantity: "",
        //         quantity_error_msg: "",
        //         unit_price: "",
        //         unit_price_error_msg: "",
        //         tax_percentage: 0,
        //         tax_percentage_error_msg: "",
        //         tax_amount_error_msg: "",
        //         amount: 0,
        //         total: 0,
        //         description: "",
        //         desc_error_msg: "",
        //         part: null,
        //         part_error_msg: "",
        //         tax_id:"",
        //         tax_amount:0,
        //         gl_account_id:null,
        //         gl_account_error_msg:"",
        //         amount_error_msg:"",
        //         enableTaxSelect:true,
        //         labor:0,
        //         labor_error_msg:"",
        //         materials:0,
        //         materials_error_msg:""
        //     });

        //     self.chrows.push({
        //         bill_item_id: 0,
        //         charge_id: null,
        //         charge_type_error_msg: "",
        //         quantity: 0,
        //         quantity_error_msg: "",
        //         unit_price: 0,
        //         unit_price_error_msg: "",
        //         amount: 0,
        //     });
        //     if (self.poDataFromWO != undefined) {
        //         if (self.poDataFromWO.poId != null) {
        //             var id = self.poDataFromWO.poId;
        //             self.loadPurchaseOrder(id);
        //             self.vendor_inv_type = "sublet_invoice";
        //             self.loadPurchaseOrderItem(id);
        //         }
        //     }

        // }else{
        // if(self.$route.query.id != undefined){
        // if (this.$route.query.data != '' && this.$route.query.data != undefined) {    
        // //   self.loadPurchaseOrder(self.$route.query.id);
        // //     self.loadPurchaseOrderItem(self.$route.query.id);
        //     self.showMoreLessLabel = "Show Less"
        //     self.showMoreLessFlag = true;
        //     $("#vendor-invoice-line-items-tbl").removeClass("less-information");
        //     var webloc = window.location.href;

        //     var decodeStr = "";
        //     decodeStr = atob(this.$route.query.data)
            
        //     var url = new URL(webloc+"?"+decodeStr);
        //     var id = url.searchParams.get("id");
        //     var type = url.searchParams.get("type");
        //     self.vendor_inv_type = type;
        //     console.log("id :: " + id);
        //     console.log("type :: " + type);
        //     self.loadPurchaseOrder(id);
        //     self.loadPurchaseOrderItem(id);
        //     /*self.disrows.push({
        //         discount_id:0,
        //         discount: 0,
        //         description: "",
        //         description_error_msg: "",
        //         gl_account_id:null,
        //         gl_account_error_msg:"",
        //         discount_error_msg:"",
        //     });*/

        //     // self.chrows.push({
        //     //     bill_item_id: 0,
        //     //     charge_id: null,
        //     //     charge_type_error_msg: "",
        //     //     quantity: 0,
        //     //     quantity_error_msg: "",
        //     //     unit_price: 0,
        //     //     unit_price_error_msg: "",
        //     //     amount: 0,
        //     // });
        // } else{
        //         var path = window.location.pathname;
        //         var segments = path.split("/");
        //         self.showMoreLessLabel = "Show Less"
        //         self.showMoreLessFlag = true;
        //         $("#vendor-invoice-line-items-tbl").removeClass("less-information");

        //         if (segments[3]) {

        //             self.bill_id = segments[3];
        //             self.loadBillDetail(segments[3]);
        //             self.isUpdate = true;

        //         }else{

        //             self.rows.push({
        //                 bill_item_id:0,
        //                 quantity: "",
        //                 quantity_error_msg: "",
        //                 unit_price: "",
        //                 unit_price_error_msg: "",
        //                 tax_percentage: 0,
        //                 tax_percentage_error_msg: "",
        //                 tax_amount_error_msg: "",
        //                 amount: 0,
        //                 total: 0,
        //                 description: "",
        //                 desc_error_msg: "",
        //                 part: null,
        //                 part_error_msg: "",
        //                 tax_id:"",
        //                 tax_amount:0,
        //                 gl_account_id:null,
        //                 gl_account_error_msg:"",
        //                 amount_error_msg:"",
        //                 enableTaxSelect:true
        //             });


        //             /*self.disrows.push({
        //                 discount_id:0,
        //                 discount: 0,
        //                 description: "",
        //                 description_error_msg: "",
        //                 gl_account_id:null,
        //                 gl_account_error_msg:"",
        //                 discount_error_msg:"",
        //             });*/

        //             self.chrows.push({
        //                 bill_item_id: 0,
        //                 charge_id: null,
        //                 charge_type_error_msg: "",
        //                 quantity: 0,
        //                 quantity_error_msg: "",
        //                 unit_price: 0,
        //                 unit_price_error_msg: "",
        //                 amount: 0,
        //             });

        //             // var todayDate = self.getTodayDate();
        //             // self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        //             // self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
        //             // self.bill_date = moment(todayDate,"MM/DD/YYYY");

        // }
        // }
        // }
    },
    methods: {
      onChangepo(evt){
        console.log(evt.value);
        var path = window.location.pathname;
        var segments = path.split("/");
            if(!segments[3]){
               this.loadPurchaseOrder(evt.value);
               this.loadPurchaseOrderItem(evt.value);

            }

      },
       loadPurchaseOrderItem(id) {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-purchase-order/items/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.rows = [];
                        self.chrows = [];
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                if (data.content[i].charge_id == null){
                                    var itemId = null;
                                    if (data.content[i].item_id != null) {
                                        itemId = {
                                            value: data.content[i].item_id,
                                            text: data.content[i].iCode + " | " + data.content[i].iName
                                        };
                                    }

                                    self.rows.push({
                                        bill_item_id: 0,

                                        description: data.content[i].description,

                                        quantity: data.content[i].quantity,
                                        quantity_error_msg: "",

                                        unit_price: data.content[i].unit_price,
                                        unit_price_error_msg: "",
                                        tax_percentage: data.content[i].tax_percentage,
                                        tax_percentage_error_msg: "",
                                        tax_id:"",

                                        amount: data.content[i].total,
                                        part: itemId,
                                        desc_error_msg:"",
                                        part_error_msg: "",
                                        labor:0,
                                        labor_error_msg:"",
                                        materials:data.content[i].total,
                                        materials_error_msg:"",
                                        gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                            value: data.content[i].gl_account_id,
                                            text: self.ucString(data.content[i].glCode + " | " + data.content[i].glDesc),
                                        } : null,
                                        gl_account_error_msg:"",
                                    })
                                }else{

                                    var chargeId = null;
                                    if (data.content[i].charge_id != null) {
                                        chargeId = {
                                            value: data.content[i].charge_id,
                                            text: data.content[i].charge_name
                                        };
                                    }

                                    self.chrows.push({
                                        bill_item_id: 0,
                                        quantity: data.content[i].quantity,
                                        quantity_error_msg: "",
                                        unit_price: data.content[i].unit_price,
                                        unit_price_error_msg: "",
                                        amount: data.content[i].total,
                                        charge_id: chargeId,
                                    })
                                }
                            }
                            if (!self.chrows || self.chrows.length == 0){
                                self.chrows.push({
                                    bill_item_id: 0,
                                    charge_id: null,
                                    charge_type_error_msg: "",
                                    quantity: 0,
                                    quantity_error_msg: "",
                                    unit_price: 0,
                                    unit_price_error_msg: "",
                                    amount: 0,
                                });
                            }
                            // self.calculateTaxSubTotal();
                        } else {
                            self.rows.push({
                                bill_item_id: 0,
                                model_code: "",
                                model_error_msg: "",
                                year: "",
                                year_error_msg: "",
                                quantity: 0,
                                quantity_error_msg: "",
                                asset_pool_id: "",
                                asset_pool_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount: 0,
                                tax_amount_error_msg: "",
                                amount: 0,
                                description: "",
                                part: "",
                                desc_error_msg:"",
                                part_error_msg: "",
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:""
                            });

                            self.chrows.push({
                                bill_item_id:0,
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                charge_id: null,
                            })
                        }
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-item')
                }
            });
        },
        loadPurchaseOrder(id) {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/purchaseorder/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);

                    if (data.status == "success") {

                        self.isEdit = true;
                        self.po ={
                            value: data.content.id,
                            text: data.content.po_no
                        };
                        self.location_id={
                          value: data.content.assigned_loc_id,
                            text: data.content.assigned_loc_name
                        }
                        self.purchase_order_type = {
                            value: data.content.type,
                            text: self.titleCase(data.content.type)
                        };
                        //disable purchase order type drop down
                        // $("#purchase_order_type").addClass("disable-field");
                        self.disablePurchaseOrderTypeField = true;

                        // self.from_where = {value: data.content.from_where, text: self.titleCase(data.content.from_where) };
                        if (data.content.type == "item") {
                            self.showItemFields = true;
                        } else {
                            self.showItemFields = false;
                        }
                        self.bill_date = data.content.order_date;
                        self.due_date = data.content.due_date;
                        self.delivery_date = data.content.delivery_date;
                        self.attention = data.content.attention;
                        self.notes = data.content.notes;
                        // self.status = data.content.status;
                        self.status = {
                            value: data.content.status,
                            text: self.titleCase(data.content.status)
                        };
                        if (data.content.assigned_loc_id == null) {
                            self.assigned_location_id = null;
                        } else {
                            self.assigned_location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ordering_loc_id == null) {
                            self.ordering_location_id = null;
                        } else {
                            self.ordering_location_id = {
                                value: data.content.ordering_loc_id,
                                text: self.titleCase(data.content.ordering_loc_name + " (" + data.content.ordering_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ship_loc_id == null) {
                            self.ship_to_location_id = null;
                        } else {
                            self.ship_to_location_id = {
                                value: data.content.ship_loc_id,
                                text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
                            };
                        }

                        // if (self.customer_id == null) {
                        //     self.customer_id="";
                        // } else{
                        //     if((data.content.cust_id)!=null)
                        //     {
                        //         var name=(data.content.cust_name != null)? data.content.cust_name :"";
                        //        var code=(data.content.cust_code != null)?data.content.cust_code:"";

                        //         self.customer_id={value: data.content.cust_id, text: self.titleCase(name + " (" + code +")")};
                        //     }
                        // }
                        if ((data.content.cust_id) != null) {
                            var name = (data.content.cust_name != null) ? data.content.cust_name : "";
                            var code = (data.content.cust_code != null) ? data.content.cust_code : "";

                            self.customer_id = {
                                value: data.content.cust_id,
                                text: self.titleCase(name + " (" + code + ")")
                            };
                        } else {
                            self.customer_id = null;
                        }

                        // if (self.sales_person_id == null) {
                        //     self.sales_person_id == "";
                        // } else{
                        //     if((data.content.sales_id)!=null)
                        //     {
                        //         var firstname=(data.content.sales_firstname != null)? data.content.sales_firstname :"";
                        //         var lastname=(data.content.sales_lastname != null)?data.content.sales_lastname:"";
                        //         self.sales_person_id={value: data.content.sales_id, text: self.titleCase(firstname + " " + lastname)};
                        //     }

                        // }
                        if ((data.content.sales_id) != null) {
                            var firstname = (data.content.sales_firstname != null) ? data.content.sales_firstname : "";
                            var lastname = (data.content.sales_lastname != null) ? data.content.sales_lastname : "";
                            self.sales_person_id = {
                                value: data.content.sales_id,
                                text: self.titleCase(firstname + " " + lastname)
                            };
                        } else {
                            self.sales_person_id = null;
                        }

                        if (data.content.vID == null) {
                            self.vendor_id = null;
                        } else {
                            self.vendor_id = {
                                value: data.content.vID,
                                text: self.titleCase(data.content.vName + " (" + data.content.vCode + ")")
                            };
                        }

                        self.showCharges = true;
                        self.sub_total = data.content.sub_total;
                        self.total_tax = data.content.total_tax;
                        self.total = data.content.total;
                        self.amount = data.content.total;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load')
                }
            });
        },

        loadBillDetail(bill_id) {

            var self = this;
            self.loading = true;


            $.ajax({
                url: process.env.ROOT_API + "/bill-detail/" + bill_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                     if (data.status == "success") {
                        self.vendor_id = {
                            value: data.content.vID,
                            text: self.titleCase(data.content.vName + " | " + data.content.vCode),
                            term_period:data.content.term_period,
                            term:data.content.term,
                            po_required:data.content.po_required,
                            required_attachment:data.content.required_attachment,
                        };
                        if ( data.content.po_required == 1 ) {
                            self.isPORequired = true;
                            self.poRequiredClass = 'required';
                        }else{
                            self.isPORequired = false;
                            self.poRequiredClass = '';
                        }
                        self.bill_date = data.content.bill_date;
                        self.due_date = data.content.due_date;
                        self.bill_number = data.content.bill_number;
                        self.notes = data.content.bill_notes;
                        self.reference = data.content.reference;
                        self.voucher = data.content.voucher_number;
                        self.assignee = data.content.assignee;
                        if (data.content.po_type != undefined) {
                            if (data.content.po_type != null && data.content.po_type != "") {
                                self.vendor_inv_type = data.content.po_type;
                            }else{
                                self.vendor_inv_type = "";
                            }
                        }else{
                            self.vendor_inv_type = "";
                        }
                        //not allow to edit if status is approved
                        if ( data.content.status == "approved" ) {
                            self.cantAccessPage = false;
                            return;
                        }

                        if (data.content.poId){

                            self.po = {
                                value: data.content.poId,
                                text: data.content.poNumber+ ' | '+self.amountFormat(data.content.poTotal)
                            };
                        }else{
                            self.po = "";
                        }
                        if (data.content.locName != null && data.content.locName != "") {
                            self.location_id = {value:data.content.location_id,text:self.ucString(data.content.locName) + " | " + data.content.locCode};
                        }else{
                            self.location_id = "";
                        }
                        setTimeout(function(){
                            self.accountCanChanged = true;
                        },2000);

                        self.loadBillItems();

                        /*setTimeout(function(){
                            self.loadBillDiscount();
                        },500);*/

                        self.sub_total = data.content.sub_total;
                        self.total_tax = data.content.tax_amount;
                        self.total = data.content.total;
                        self.existFilesArr = data.content.docs;
                        setTimeout(function(){
                            self.watchCall = true;
                        },500);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-details');
                }
            });
        },

        loadBillItems() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.rows = [];
                        self.chrows = [];
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                 if (data.content[i].charge_id == null){
                                    var itemId = null;
                                    if (data.content[i].iId != null) {
                                        itemId = {
                                            value: data.content[i].iId,
                                            text: data.content[i].iCode + " | " + data.content[i].iName
                                        };
                                    }
                                    self.rows.push({
                                        bill_item_id:data.content[i].id,
                                        part:itemId,
                                        description:data.content[i].description,
                                        desc_error_msg:"",
                                        quantity:(data.content[i].item_qty > 0 )?data.content[i].item_qty:"",
                                        quantity_error_msg:"",
                                        unit_price:(data.content[i].item_price > 0 )?data.content[i].item_price:"",
                                        unit_price_error_msg:"",
                                        amount:(data.content[i].item_total + data.content[i].tax).toFixed(2),
                                        tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            value: data.content[i].tax_id,
                                            text: data.content[i].tax_name,
                                            percentage:data.content[i].tax_percentage,
                                        } : "",
                                        tax_amount:data.content[i].tax,
                                        total:data.content[i].item_total + data.content[i].tax,
                                        gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                            value: data.content[i].gl_account_id,
                                            text: self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc),
                                        } : null,
                                        gl_account_error_msg:"",
                                        amount_error_msg:"",
                                        enableTaxSelect:(data.content[i].item_qty > 0 || data.content[i].item_price)?false:true
                                    });
                                    // if (data.content[i].charge_id == null){
                                    //     self.chrows.push({
                                    //         bill_item_id:0,
                                    //         charge_id:null,
                                    //         quantity:'',
                                    //         quantity_error_msg:"",
                                    //         unit_price:"",
                                    //         unit_price_error_msg:"",
                                    //         amount:0,
                                    //         amount_error_msg:"",
                                    //         total:'',
                                    //     });
                                    // }
                                }else{

                                    var chargeId = null;
                                    if (data.content[i].charge_id != null) {
                                        chargeId = {
                                            value: data.content[i].charge_id,
                                            text: data.content[i].charge_name
                                        };
                                    }
                                    self.chrows.push({
                                        bill_item_id:data.content[i].id,
                                        charge_id:chargeId,
                                        quantity:(data.content[i].item_qty > 0 )?data.content[i].item_qty:"",
                                        quantity_error_msg:"",
                                        unit_price:(data.content[i].item_price > 0 )?data.content[i].item_price:"",
                                        unit_price_error_msg:"",
                                        amount:(data.content[i].item_total + data.content[i].tax).toFixed(2),
                                        amount_error_msg:"",
                                        total:data.content[i].item_total + data.content[i].tax,
                                    });
                                }
                            }

                                if (!self.chrows || self.chrows.length == 0){
                                    self.chrows.push({
                                        bill_item_id: 0,
                                        charge_id: null,
                                        charge_type_error_msg: "",
                                        quantity: 0,
                                        quantity_error_msg: "",
                                        unit_price: 0,
                                        unit_price_error_msg: "",
                                        amount: 0,
                                    });
                                }

                        }else{

                            self.rows.push({
                                bill_item_id:0,
                                quantity: "",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true
                            });

                            self.chrows.push({
                                bill_item_id:0,
                                charge_id:null,
                                quantity:'',
                                quantity_error_msg:"",
                                unit_price:"",
                                unit_price_error_msg:"",
                                amount:0,
                                amount_error_msg:"",
                                total:'',
                            });
                        }
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items');
                }
            });
        },

        loadBillDiscount() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/discount-item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                        self.disrows = [];

                        if (data.content.length >= 1) {
                            var totalDiscount = 0;
                            for (var i = 0; i < data.content.length; i++) {
                                self.disrows.push({
                                    discount_id:data.content[i].id,
                                    description:data.content[i].description,
                                    description_error_msg:"",
                                    discount:parseFloat(data.content[i].discount),
                                    discount_error_msg:"",
                                    gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                        value: data.content[i].gl_account_id,
                                        text: self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc),
                                    } : null,
                                    gl_account_error_msg:"",
                                });

                                totalDiscount += parseFloat(data.content[i].discount);
                            }
                            self.totalDiscount = totalDiscount;
                            self.total -= self.totalDiscount;

                        }else{

                            self.disrows.push({
                                discount_id:0,
                                description:'',
                                description_error_msg:"",
                                discount:0,
                                discount_error_msg:"",
                                gl_account_id:'',
                                gl_account_error_msg:"",
                            });
                        }
                        if ( self.disrows.length > 1) {
                            self.showTotalSummary = true;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-discount');
                }
            });
        },



        handleFilesUpload: function(event) {
            /* Get the uploaded files from the input.*/
            var self = this;
            if (!self.isUpdate) {

                self.filesArr = [];
                self.fileerroor_msg = "";

                let uploadedFiles = "";
                self.uploadBtn= "Uploading...";
                uploadedFiles = self.$refs.files.files;
                for (var i = 0; i < uploadedFiles.length; i++) {

                    this.filesArr.push(uploadedFiles[i]);

                }
                console.log(this.filesArr);
                this.$refs.files.value = '';
                self.uploadBtn= "Upload";
            }else{

                if ( self.existFilesArr.length > 0 ) {

                    if (confirm('Do you want to upload file? ')) {

                        self.filesArr = [];
                        self.fileerroor_msg = "";

                        let uploadedFiles = "";
                        self.uploadBtn= "Uploading...";
                        uploadedFiles = self.$refs.files.files;
                        for (var i = 0; i < uploadedFiles.length; i++) {

                            this.filesArr.push(uploadedFiles[i]);

                        }
                        console.log(this.filesArr);
                        this.$refs.files.value = '';
                        self.uploadBtn= "Upload";
                        self.isUpdate = false;
                    }
                    
                }else{
                    self.isUpdate = false;
                    self.filesArr = [];
                    self.fileerroor_msg = "";

                    let uploadedFiles = "";
                    self.uploadBtn= "Uploading...";
                    uploadedFiles = self.$refs.files.files;
                    for (var i = 0; i < uploadedFiles.length; i++) {

                        this.filesArr.push(uploadedFiles[i]);

                    }
                    console.log(this.filesArr);
                    this.$refs.files.value = '';
                    self.uploadBtn= "Upload";
                }

            }

        },
         deleteDoc: function(id,key) {
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {
                self.submitBtn = false;
                console.log( self.$refs.files);
                this.filesArr.splice(key,1)
                self.$refs.files.value = '';
                if (self.valuesFound) {
                    self.valuesFound = false;
                    self.matchingValuesError = [];
                }
            }
            
            return;

        },

        calculateAmount($event, index) {
            // alert(index);
            var self = this;
            if (self.rows[index].quantity == 0 || self.rows[index].unit_price == 0 || self.rows[index].quantity == null ||
                self.rows[index].unit_price == null) {
                self.rows[index].tax_percentage = 0;
            }

            if ( self.rows[index].quantity > 0 || self.rows[index].unit_price > 0 ) {
                self.rows[index].enableTaxSelect = false;
            }else{
                self.rows[index].enableTaxSelect = true;
            }
            self.calculateTaxSubTotal();

        },
        taxPercentage($event, index) {
            var self = this;

            if (self.rows[index].quantity && self.rows[index].unit_price) {
                self.calculateTaxSubTotal();
            } else {
                self.rows[index].tax_percentage = "";
                if (self.rows[index].quantity == null || !self.rows[index].quantity) {
                    self.rows[index].quantity_error_msg = "Quantity is Required.";
                }
                if (self.rows[index].unit_price == null || !self.rows[index].unit_price) {
                    self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                }
            }

        },
        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 1) {
                loading(true);
                self.searchField(loading, search, 'component', '');
            }
        },

        onSearchVendor(search, loading) {
            var self = this;
            self.po_error_msg = "";
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'bill_vendor', '');
            }
        },
        onTaxSelect(event,index) {
            var self = this;
            // alert(self.rows[index].tax_id.percentage);
            if( self.rows[index].tax_id != null && self.rows[index].tax_id != ""){
                self.rows[index].tax_amount =  parseFloat(( self.rows[index].amount * self.rows[index].tax_id.percentage ) / 100);
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
                self.rows[index].amount = parseFloat(self.rows[index].amount) + self.rows[index].tax_amount;
            }else{
                self.rows[index].tax_amount = 0;
                // self.rows[index].amount = self.rows[index].amount;
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
                self.rows[index].amount = parseFloat(self.rows[index].amount) + self.rows[index].tax_amount;
            }

            self.calculateTaxSubTotal();
        },
        addRow: function () {

            var self = this;
            var index = self.rows.length - 1;

            self.rows[index].quantity_error_msg = "";
            self.rows[index].unit_price_error_msg = "";
            self.rows[index].part_error_msg = "";
            self.rows[index].desc_error_msg = "";
            self.rows[index].gl_account_error_msg = "";
            self.rows[index].amount_error_msg = "";


            if( String(self.rows[index].quantity).includes(':')){

                var quant = self.rows[index].quantity.split(':');
                self.rows[index].quantity = quant[0];
            }

            if (((self.rows[index].part != null && self.rows[index].part.value) || (self.rows[index].description != null && self.rows[index].description != "")) &&
                self.rows[index].quantity > 0 && self.rows[index].unit_price > 0 && self.rows[index].quantity != null) {
                // self.rows[index].quantity > 0 && self.rows[index].unit_price > 0 && self.rows[index].quantity != null && (self.rows[index].gl_account_id != null && self.rows[index].gl_account_id.value)) {    
            // if ((self.rows[index].description != null && self.rows[index].description != "" && self.rows[index].description.trim() != "") && ( self.rows[index].amount != null && self.rows[index].amount != "")
            //  && (self.rows[index].gl_account_id != null && self.rows[index].gl_account_id.value) && (self.rows[index].quantity != 0 && self.rows[index].quantity != "") && (self.rows[index].unit_price != 0 && self.rows[index].unit_price != "")) {
                // && (self.rows[index].quantity != 0 && self.rows[index].quantity != "") && (self.rows[index].unit_price != 0 && self.rows[index].unit_price != "")) {
                self.rows.push({
                    bill_item_id:0,
                    quantity: "",
                    quantity_error_msg: "",
                    unit_price: "",
                    unit_price_error_msg: "",
                    tax_percentage: 0,
                    tax_percentage_error_msg: "",
                    tax_amount: 0,
                    tax_amount_error_msg: "",
                    amount: 0,
                    total: 0,
                    description: "",
                    desc_error_msg: "",
                    part: null,
                    part_error_msg: "",
                    tax_id:"",
                    gl_account_id:null,
                    gl_account_error_msg:"",
                    amount_error_msg:"",
                    enableTaxSelect:true
                });

            } else {

                /*if (self.rows[index].quantity == null || !self.rows[index].quantity) {
                    self.rows[index].quantity_error_msg = "Quantity is Required.";
                }
                if (self.rows[index].unit_price == null || !self.rows[index].unit_price) {
                    self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                }
                if ((self.rows[index].part == null || !self.rows[index].part.value) && (self.rows[index].description == null || self.rows[index].description == "")) {

                    if (self.rows[index].part == null || !self.rows[index].part.value) {
                        self.rows[index].part_error_msg = "Part is Required.";
                    }
                    if (self.rows[index].description == null || self.rows[index].description == "") {
                        self.rows[index].desc_error_msg = "Description is Required.";
                    }

                }
                if (self.rows[index].part == null || !self.rows[index].part.value) {
                    self.rows[index].part_error_msg = "Part is Required.";
                }*/
                if ((self.rows[index].part == null || !self.rows[index].part.value) && (self.rows[index].description == null || self.rows[index].description == "")) {

                    if (self.rows[index].part == null || !self.rows[index].part.value) {
                        self.rows[index].part_error_msg = "Part is Required.";
                    }
                    if (self.rows[index].description == null || self.rows[index].description == "") {
                        self.rows[index].desc_error_msg = "Description is Required.";
                    }

                }
                // if (self.rows[index].description == null || self.rows[index].description == "") {
                //     self.rows[index].desc_error_msg = "Description is Required.";
                // }
                /*if (self.rows[index].gl_account_id == null || !self.rows[index].gl_account_id.value) {
                    self.rows[index].gl_account_error_msg = "GL Account is Required.";
                }*/
                if (self.rows[index].amount == null || self.rows[index].amount == "" ) {
                    self.rows[index].amount_error_msg = "Amount Required.";
                }
                if (self.rows[index].quantity == '' || self.rows[index].amount == 0 ) {
                    self.rows[index].quantity_error_msg = "Qty Required.";
                }
                if (self.rows[index].unit_price == '' || self.rows[index].unit_price == 0 ) {
                    self.rows[index].unit_price_error_msg = "Unit Price Required.";
                }
            }
            if ( self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        removeElement: function (index) {
            var self = this;
            if (self.rows.length > 1) {
                if (self.rows[index].bill_item_id == 0) {
                    self.rows.splice(index, 1);
                    self.calculateTaxSubTotal();

                } else {
                    if (confirm('Are you sure that you want to delete this Vendor Invoice Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/bill-item/delete",
                            type: "POST",
                            data: {
                                'id': self.rows[index].bill_item_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.rows.splice(index, 1);
                                    self.calculateTaxSubTotal();
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-item-delete');
                            },
                        });
                    }
                }
            }
            if ( self.rows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
         addLine: function () {

            var self = this;
            var index = self.rows.length - 1;

            self.chrows[index].quantity_error_msg = "";
            self.chrows[index].unit_price_error_msg = "";
            self.chrows[index].charge_type_error_msg = "";

            if (self.chrows[index].charge_id != null && self.chrows[index].charge_id.value && self.chrows[index].quantity &&
                self.chrows[index].unit_price) {

                self.chrows.push({
                    bill_item_id: 0,
                    charge_id: null,
                    charge_type_error_msg: "",
                    quantity: 0,
                    quantity_error_msg: "",
                    unit_price: 0,
                    unit_price_error_msg: "",
                    amount: 0,
                });

            } else {
                if (self.chrows[index].quantity == null || !self.chrows[index].quantity) {
                    self.chrows[index].quantity_error_msg = "Quantity is Required.";
                }
                if (self.chrows[index].unit_price == null || !self.chrows[index].unit_price) {
                    self.chrows[index].unit_price_error_msg = "Unit Price is Required.";
                }
                if (self.chrows[index].charge_id == null || !self.chrows[index].charge_id.value) {
                    self.chrows[index].charge_type_error_msg = "Charge Type is Required.";
                }
            }

            if ( self.chrows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        removeChargeElement: function (index) {
            var self = this;
            if (self.chrows.length > 1) {
                if (self.chrows[index].bill_item_id == 0) {
                    self.chrows.splice(index, 1);
                    self.calculateChargeAmount('',index);

                } else {
                    if (confirm('Are you sure that you want to delete this Charges Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/bill-item/delete",
                            type: "POST",
                            data: {
                                'id': self.chrows[index].bill_item_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.chrows.splice(index, 1);
                                    self.calculateChargeAmount('',index);
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-delete-item')
                            },
                        });
                    }
                }
            }
            if (self.chrows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = false;
            }
        },
        calculateChargeAmount:function(evt,index){
            var self = this;

            var amount = 0;
            var totalAmount = 0
            var charges = 0;
            self.chrows[index].amount = self.chrows[index].quantity * self.chrows[index].unit_price;

            for (var j = 0; j < self.rows.length; j++) {

                totalAmount += parseFloat(self.rows[j].amount);

            }

            for (var k = 0; k < self.chrows.length; k++) {

                charges += parseFloat(self.chrows[k].amount);

            }

            self.sub_total = totalAmount + charges;
            self.showTotalSummary = true;
        },
        calculateTaxSubTotal() {
            var self = this;
            var amount = 0;
            var taxAmount = 0

            for (var i = 0; i < self.rows.length; i++) {

                if( String(self.rows[i].quantity).includes(':')){

                    var quant = self.rows[i].quantity.split(':');
                    self.rows[i].quantity = quant[0];
                }

                // console.log(self.rows[i].quantity * parseFloat(self.rows[i].unit_price));
                // self.rows[i].amount = self.rows[i].quantity * parseFloat(self.rows[i].unit_price);
                // self.rows[i].tax_amount = (self.rows[i].amount * self.rows[i].tax_percentage) / 100;
                // alert(self.rows[i].tax_amount);
                // self.rows[i].total = self.rows[i].amount;
                // self.rows[i].total = self.rows[i].amount + self.rows[i].tax_amount;

                if (self.rows[i].quantity > 0 || self.rows[i].unit_price > 0 ) {

                    self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;
                    self.rows[i].amount = parseFloat(self.rows[i].amount);
                    // self.rows[i].amount = self.rows[i].amount.toFixed(2);
                    if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                        self.rows[i].tax_amount =  parseFloat(( self.rows[i].amount * self.rows[i].tax_id.percentage ) / 100);
                    }else{
                        self.rows[i].tax_amount = 0;
                    }
                    self.rows[i].total = self.rows[i].amount;
                    self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                    amount += parseFloat(self.rows[i].amount);
                    self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                    taxAmount += parseFloat(self.rows[i].tax_amount);
                    var formatAmount = self.rows[i].amount.toFixed(2);
                    self.rows[i].amount = formatAmount;

                }else{
                    if (self.rows[i].amount != "") {
                        // self.rows[i].amount = parseFloat(self.rows[i].amount);
                        self.rows[i].total = self.rows[i].amount;
                        if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                            self.rows[i].tax_amount =  parseFloat(( self.rows[i].amount * self.rows[i].tax_id.percentage ) / 100);
                        }else{
                            self.rows[i].tax_amount = 0;
                        }
                        self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                        amount += parseFloat(self.rows[i].amount);
                        // self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                        taxAmount += parseFloat(self.rows[i].tax_amount);
                    }
                }

                // if ( self.rows[i].tax_amount){

                //     self.rows[i].amount = parseFloat(self.rows[i].amount + self.rows[i].tax_amount);
                // }else{

                //     self.rows[i].amount = parseFloat(self.rows[i].amount);
                // }

                // self.rows[i].amount = self.rows[i].amount.toFixed(2);
            }

            // self.sub_total = "";
            //previous
            // self.sub_total = self.rows.reduce(function(prev, cur) {
            //     return prev + cur.amount;
            // }, 0);
            // self.sub_total = self.rows.reduce(function (prev, cur) {
            //     return prev + (cur.quantity * cur.unit_price);
            // }, 0);

            // self.total_tax = "";
            // self.total_tax = self.rows.reduce(function (prev, cur) {
            //     return prev + cur.tax_amount;
            // }, 0);
            self.sub_total = parseFloat(amount);
            self.total_tax= parseFloat(taxAmount);
            self.pre_subtotal = self.sub_total;

            var charges = 0;
            for (var k = 0; k < self.chrows.length; k++) {

                charges += parseFloat(self.chrows[k].amount);

            }
            self.sub_total += charges;

        },
        calculateDiscount:function(evt,index){
            var self = this;

            var total = self.sub_total;

            var amount = 0;
            var totalAmount = 0
            var disTotal = 0;

            for (var j = 0; j < self.rows.length; j++) {

                totalAmount += parseFloat(self.rows[j].amount);

            }

            for (var k = 0; k < self.disrows.length; k++) {

                disTotal += parseFloat(self.disrows[k].discount);

            }

            self.totalDiscount = disTotal;
            amount = totalAmount - disTotal;

            if (amount > 0){

                self.total = parseFloat(amount);

            }
            self.showTotalSummary = true;

        },
        BillList() {
            var self = this;
            if(self.redirectFrom != undefined && self.redirectFrom != '' && (self.redirectFrom == 'poview' || self.redirectFrom == "poreceipttab") && self.poId != null && self.poId != ''){
                self.$router.push('/vendor-purchase-order/view/'+self.poId);
            }else{
                if (self.redirectFrom != undefined && self.redirectFrom != '' && (self.redirectFrom == 'receiptcreate' || self.redirectFrom == 'receiptview') && self.receipt_id != null && self.receipt_id != "") {
                    self.$router.push("/record-receipt/view/"+self.receipt_id);
                }else if (self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'approveorder'){
                    self.$router.push("/order/list");
                }else{
                    self.$router.push("/vendor-invoice/list");
                }                
            }
        },

        CreateBill(flag) {
            var self = this;
            var error = false;
            // self.status_error_msg = "";
            self.bill_date_error_msg = "";
            self.due_date_error_msg = "";
            self.bill_error = '';
            // self.location_error_msg = "";
            self.vendor_error_msg = "";
            self.po_error_msg = "";
            self.fileerror_msg = '';
            self.matchingValuesError = [];

            if (!self.bill_date || self.bill_date == null || self.bill_date == "") {
                self.bill_date_error_msg = "Invoice Date Required.";
                error = true;
            }
            if (!self.bill_number || self.bill_number == null || self.bill_number == "") {
                self.bill_error = "Invoice Number Required.";
                error = true;
            }

            if (!self.vendor_id || self.vendor_id == null || self.vendor_id == "") {
                self.vendor_error_msg = "Vendor Required.";
                error = true;
            }

            /*if (!self.status || self.status == null || self.status == "") {
                self.status_error_msg = "Status Required.";
                error = true;
            }*/
            /*if ( self.location_id == null ) {
                self.location_error_msg = "Location Required.";
                error = true;
            }*/

            // if (self.isPORequired) {
                if (!self.po || self.po == null || self.po == "") {
                    self.po_error_msg = "PO Required.";
                    error = true;
                }
            // }

            // if (!self.filesArr.length ){

            //     self.fileerror_msg = 'File Required';
            //     error = true;
            // }
            if ( self.bill_date != null && self.due_date != null && self.bill_date != "" && self.due_date != "" ) {
                var invoiceDate = Date.parse(self.bill_date);
                var dueDate = Date.parse(self.due_date);

                if( dueDate <= invoiceDate ) {
                    self.due_date_error_msg = "Due Date should be greater than Invoice Date.";
                    error = true;
                }
            }

            if ( self.filesArr.length > 0 ) {
                for (var i = 0; i < self.filesArr.length; i++) {

                    let file = self.filesArr[i];
                    // if(file.size > 5000000){
                    //     self.docerrors = 'File Size Should Not Be Greater Than 5 MB';
                    // }
                    if(file.type == "image/jpeg" || file.type == "image/png" || file.type == 'application/pdf') {

                    } else {
                        self.fileerror_msg = 'Only Images or PDF Files Are Allowed (.png / .jpeg / .pdf)';
                        error = true;
                    }
                }
            }


            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;


            for (var i = 0; i < self.rows.length; i++) {
                    // console.log(self.rows[i]);
                //from work order view    
                if (self.poInvoiceFromWO != undefined) {
                    self.rows[i].desc_error_msg = "";
                    self.rows[i].labor_error_msg = "";
                    self.rows[i].materials_error_msg = "";
                    self.rows[i].amount_error_msg = "";

                    if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                        self.rows[i].quantity_error_msg = "Quantity is Required.";
                        error = true;
                    }

                    if ((self.rows[i].labor == null || !self.rows[i].labor) && (self.rows[i].materials == null || !self.rows[i].materials)) {
                        if (self.rows[i].labor == null || !self.rows[i].labor) {
                            self.rows[i].labor_error_msg = "Labor Amount is Required.";
                            error = true;

                        }
                        if (self.rows[i].materials == null || !self.rows[i].materials) {
                            self.rows[i].materials_error_msg = "Material Amount is Required.";
                            error = true;
                        }
                    }else{
                        //check whether total of labor and materials is equal to amount or not
                        if ((self.rows[i].labor != "") || (self.rows[i].materials != "")) {
                            
                            var checkAmount = 0;
                            var found = "";
                            console.log(self.rows[i].labor);
                            console.log(self.rows[i].materials);
                            if (self.rows[i].labor != "") {
                                checkAmount += Number(self.rows[i].labor);
                                found += "labor";
                            }
                            if (self.rows[i].materials != "") {
                                checkAmount += Number(self.rows[i].materials);
                                found += "material";
                            }
                            console.log("check amount :: " + checkAmount);
                            /*if (checkAmount != Number(self.rows[i].amount)) {
                                if (found == "labor") { 
                                    self.$swal('',"Labor Amount does not match with Amount.",'info');
                                }else if (found == "material") {
                                    self.$swal('',"Material Amount does not match with Amount.",'info');
                                }else{
                                    self.$swal('',"Sum of Labor Amount and Material Amount does not match with Amount.",'info');
                                }
                                error = true;
                            }*/
                        }
                    }

                    if (self.rows[i].description == null || self.rows[i].description == "") {
                        self.rows[i].desc_error_msg = "Description is Required.";
                        error = true;
                    }

                    if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                        self.rows[i].amount_error_msg = "Amount Required.";
                        error = true;
                    }
                }else{    
                self.rows[i].desc_error_msg = "";
                self.rows[i].unit_price_error_msg = "";
                self.rows[i].quantity_error_msg = "";
                self.rows[i].part_error_msg = "";
                self.rows[i].gl_account_error_msg = "";
                self.rows[i].amount_error_msg = "";

                if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                    self.rows[i].unit_price_error_msg = "Unit Price is Required.";
                    error = true;
                }

                if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                    self.rows[i].quantity_error_msg = "Quantity is Required.";
                    error = true;
                }

               /* if ((self.rows[i].part == null || !self.rows[i].part.value) && (self.rows[i].description == null || self.rows[i].description == "")) {
                    if (self.rows[i].part == null || !self.rows[i].part.value) {
                        self.rows[i].part_error_msg = "Part is Required.";
                        error = true;

                    }
                    if (self.rows[i].description == null || self.rows[i].description == "") {
                        self.rows[i].desc_error_msg = "Description is Required.";
                        error = true;

                    }
                }
                if (self.rows[i].part == null || !self.rows[i].part.value) {
                    self.rows[i].part_error_msg = "Part is Required.";
                    error = true;

                }*/
                if ((self.rows[i].part == null || !self.rows[i].part.value) && (self.rows[i].description == null || self.rows[i].description == "")) {
                    if (self.rows[i].part == null || !self.rows[i].part.value) {
                        self.rows[i].part_error_msg = "Part is Required.";
                        error = true;

                    }
                    if (self.rows[i].description == null || self.rows[i].description == "") {
                        self.rows[i].desc_error_msg = "Description is Required.";
                        error = true;

                    }
                }
                /*if (self.rows[i].description == null || self.rows[i].description == "" || self.rows[i].description.trim() == "") {
                    self.rows[i].desc_error_msg = "Description is Required.";
                    error = true;

                }*/
                /*if (self.rows[i].gl_account_id == null || !self.rows[i].gl_account_id.value) {
                    self.rows[i].gl_account_error_msg = "GL Account is Required.";
                    error = true;
                }*/
                if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                    self.rows[i].amount_error_msg = "Amount Required.";
                    error = true;
                }
                }
            }
            /*if (self.disrows.length > 1){
                for (var i = 0; i < self.disrows.length; i++) {
                    self.disrows[i].description_error_msg = "";
                    self.disrows[i].gl_account_error_msg = "";
                    self.disrows[i].discount_error_msg = "";
                    if (self.disrows[i].description == null || self.disrows[i].description == "" || self.disrows[i].description.trim() == "") {
                        self.disrows[i].description_error_msg = "Description is Required.";
                        error = true;

                    }
                    if (self.disrows[i].gl_account_id == null || !self.disrows[i].gl_account_id.value) {
                        self.disrows[i].gl_account_error_msg = "GL Account is Required.";
                        error = true;
                    }
                    if (self.disrows[i].discount == null || self.disrows[i].discount == "" ) {
                        self.disrows[i].discount_error_msg = "Discount Required.";
                        error = true;
                    }
                }
            }*/


            if ( self.bill_date != "" && self.due_date != "" && self.bill_number != "" ) {

                if ( self.valuesFound ) {

                    if ( self.pdfArr.invDate != undefined && self.pdfArr.invDate != null && self.pdfArr.invDate != "") {

                        if ( $("#bill_date").val() != self.pdfArr.invDate ) {
                            self.matchingValuesError.push("Invoice Date");
                        }

                    }

                    if ( self.pdfArr.invDueDate != undefined && self.pdfArr.invDueDate != null && self.pdfArr.invDueDate != "") {

                        if ( $("#due_date").val() != self.pdfArr.invDueDate ) {
                            self.matchingValuesError.push("Due Date");
                        }

                    }

                    if ( self.pdfArr.invNo != undefined && self.pdfArr.invNo != null && self.pdfArr.invNo != "") {

                        if ( self.bill_number != self.pdfArr.invNo ) {
                            self.matchingValuesError.push("Invoice #");
                        }
                    }

                    if ( self.pdfArr.invAmount != undefined && self.pdfArr.invAmount != null && self.pdfArr.invAmount != "") {

                        if ( self.total != self.pdfArr.invAmount ) {
                            self.matchingValuesError.push("Total");
                        }
                    }

                }
            }
            console.log(self.matchingValuesError);

            if ( self.valuesFound && self.matchingValuesError.length > 0 ) {
                $("#error-message-modal").modal("show");
                error = true;
            }

            // return;

            if (!error) {

                var path = window.location.pathname;
                var segments = path.split("/");
                var chargeIdsArr = [];
                var typesArr = [];
                var amountArr = [];
                var taxPercentageArr = [];
                var totalChargeArr = [];


                const fields = new FormData();

                fields.append('items',JSON.stringify($("#BillForm").serializeArray()));
                // alert(JSON.stringify(fields));

                if (self.vendor_id == null) {
                    fields.append(
                        "vendor_id",
                        ""
                    );
                } else {
                    fields.append(
                        "vendor_id",
                        self.vendor_id.value
                    );
                }

                if ( parseInt(self.total) > 0){

                    fields.append(
                        "billItems",
                        JSON.stringify(self.rows)
                    );
                }else{
                    fields.append(
                        "billItems",
                         []
                    );
                }

                if ( self.disrows && self.disrows.length > 0){

                    fields.append(
                        "discountItems",
                        JSON.stringify(self.disrows)
                    );
                }else{
                    fields.append(
                        "discountItems",
                         []
                    );
                }

                if ( self.chrows[0].charge_id != null){

                    fields.append(
                        "chargesItem",
                        JSON.stringify(self.chrows)
                    );
                }else{
                    fields.append(
                        "chargesItem",
                        []
                    );
                }

                fields.append(
                    "voucher_number",
                    self.voucher
                );
                for (var i = 0; i < self.filesArr.length; i++) {
                    let file = this.filesArr[i];
                    fields.append("files[]", file);
                }

                fields.append(
                    "amount",
                    self.total
                );

                if (self.poInvoiceFromWO != undefined) {
                    fields.append(
                        "id",
                        ""
                    );
                }else{
                    fields.append(
                        "id",
                        segments[3]
                    );
                }

                fields.append(
                    "vendor_inv_type",
                    self.vendor_inv_type
                );

                if (self.po == null || self.po == "") {
                    fields.append("po", "");
                } else{
                    fields.append("po", self.po.value);
                }
                if (self.location_id == null || self.location_id == "") {
                    fields.append("location_id", "");
                } else{
                    fields.append("location_id", self.location_id.value);
                }

                // console.log(fields);
                if (self.po.value && self.po.amount && self.po.amount != self.total && !segments[3]){
                    if (confirm('PO and Invoice amount are different')) {
                        self.createBillAPI(fields,flag);
                    }else{
                        return;
                    }
                }else{
                    self.createBillAPI(fields,flag);
                }

            }else{
                self.errorValidationFocus();
            }
        },
        createBillAPI:function(fields,flag){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loading = true;

            if (segments[3]) {
                    $("#CreateBillBtn").val("Updating ...");
                    // $("#CreateBillBtn").prop("disabled", true);
                    // $("#CreateBillBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueBillBtn").val("Saving ...");
                        $("#CreateBillBtn").prop("disabled", true);
                        $("#createAndContinueBillBtn").prop("disabled", true);
                        $("#cancelBillBtn").prop("disabled", true);

                    } else {

                        $("#CreateBillBtn").val("Saving ...");
                        $("#CreateBillBtn").prop("disabled", true);
                        $("#createAndContinueBillBtn").prop("disabled", true);
                        $("#cancelBillBtn").prop("disabled", true);
                    }
                }

            $.ajax({
                url: process.env.ROOT_API + "/bill/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (segments[3]) {
                        $("#CreateBillBtn").val("Update");
                        $("#CreateBillBtn").prop("disabled", false);
                        $("#cancelBillBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueBillBtn").val("Save and Continue");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        } else {

                            $("#CreateBillBtn").val("Save");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        }
                    }
                    if (data.status == "success") {

                        self.showCharges = false;

                        if (flag == "Save and Continue") {

                            $("#BillForm").trigger("reset");
                            self.bill_number = "";
                            self.bill_date = "";
                            self.due_date = "";
                            self.vendor_id = null;
                            self.notes = "";
                            self.reference = "";
                            /*self.status = {
                                value: "open",
                                text: "Open"
                            };*/
                            //self.getPurchaseOrderNo();
                            self.rows = [];

                            self.rows.push({
                                bill_item_id: 0,
                                quantity: "",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount: 0,
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                part: null,
                                desc_error_msg:'',
                                part_error_msg: "",
                                tax_id:'',
                                gl_account_id:"",
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true
                            });

                            self.disrows = [];

                            /*self.disrows.push({
                                discount_id:0,
                                discount: 0,
                                description: "",
                                description_error_msg: "",
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                discount_error_msg:"",
                            });*/

                            self.po = '';
                            self.filesArr = [];
                            self.location_id = '';

                            self.sub_total = 0;
                            self.sub_total.toFixed(2);

                            self.totalDiscount = 0;

                            self.total_tax = 0;
                            self.total_tax.toFixed(2);

                            self.total = 0;
                            self.showTotalSummary = false;

                            var todayDate = self.getTodayDate();
                            self.bill_date = moment(todayDate,"MM/DD/YYYY");
                            self.isPORequired = false;
                            self.poRequiredClass = '';

                        } else {
                            //from work order view page
                            if (self.poInvoiceFromWO != undefined) {
                                self.$parent.hideInvoicePOForm();
                                self.$parent.loadWorkOrderDetail();
                            }else{
                                self.$router.push("/vendor-invoice/view/"+data.content.id);
                            }
                            
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3]) {
                        $("#CreatePurchaseOrderBtn").val("Update");
                        $("#CreatePurchaseOrderBtn").prop("disabled", false);
                        $("#cancelPurchaseOrderBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueBillBtn").val("Save and Continue");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        } else {

                            $("#CreateBillBtn").val("Save");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-create');
                }
            });
        },
        onSearchPurchaseOrder(search, loading) {
            var self = this;
            self.po_error_msg = "";
            if ( self.vendor_id != null && self.vendor_id.value != "" ) {
                if (search.length > 0 ){
                    self.searchPo(search);
                }
            }else{
                self.po_error_msg = "Vendor Required.";
            }
        },
        //purchase order for customer with status open
        searchPo(searchValue) {

            var self = this;

            // self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/po/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {
                    // customer_id: custId,
                    search: searchValue,
                    flag: "vendor",
                    vendor:self.vendor_id.value
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.purchaseOrderArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'search-vendor-po');
                }
            });
        },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        BackBillList() {
            var self = this;
            //hide form in work order view
            if (self.poInvoiceFromWO != undefined) {
                self.$parent.hideInvoicePOForm();
            }else{
                self.$router.push({ name: 'BillList'})
            }
        },
        deleteBillFile: function(key,file){

            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                if(self.bill_id != '' && self.bill_id != undefined){

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/remove-bill-file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            bill_id:self.bill_id,
                            doc_path:file
                        },
                        success: function(data) {
                            self.loading = false;
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {

                                self.loadBillDetail(self.bill_id);
                                // $("#myModal").modal("hide");
                                self.$refs.files.value = '';
                                self.existFilesArr = [];
                                if (self.valuesFound) {
                                    self.valuesFound = false;
                                    self.matchingValuesError = [];
                                }
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.files.splice(key,1);
                            self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-doc-remove');
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';
                }
            }
        },
        amountFormat(amount) {

            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        onVendorChange() {
            console.log("onVendorChange");
            var self = this;
            self.vendor_error_msg = "";
            self.po_error_msg = "";
            self.due_date_error_msg = "";
            if (self.vendor_id != null && self.vendor_id != "" ) {

                if ( self.vendor_id.term != null ) {

                    var date = '';
                    if ( self.vendor_id.term_period != null ) {
                        if(self.vendor_id.term_period == 'month'){
                            date = moment(self.bill_date, "MM/DD/YYYY")
                                    .add(self.vendor_id.term,'month') //replace 2 with number of days you want to add

                        }else{

                            date = moment(self.bill_date, "MM/DD/YYYY")
                                    .add(self.vendor_id.term,'days');
                        }
                        //populate due date on the basis of terms if due date is blank
                        if (self.due_date == "" || self.due_date == null) {
                            self.due_date = date;
                        }
                    }else{
                        // self.due_date = "";
                    }
                }else{
                    // self.due_date = "";
                }
                self.po = '';
                self.vendor_inv_type = "";
                self.purchaseOrderArr = [];
                if ( self.vendor_id.po_required == 1 ) {
                    self.isPORequired = true;
                    self.poRequiredClass = 'required';
                }else{
                    self.isPORequired = false;
                    self.poRequiredClass = '';
                }
            }else{
                // self.due_date = "";
                self.po = '';
                self.purchaseOrderArr = [];
                self.isPORequired = false;
                self.poRequiredClass = '';
            }
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                if (self.location_id != null && self.location_id.value){

                    self.searchField(loading, search, 'accounts',self.location_id.value);

                }else{

                    self.searchField(loading, search, 'accounts', '');

                }
            }
        },
        hideMessageModal() {
            var self = this;
            self.matchingValuesError = [];
            $("#error-message-modal").modal("hide");
        },
        submitBill() {
            var self = this;
            $("#error-message-modal").modal("hide");
            self.valuesFound = false;
            self.matchingValuesError = [];
            self.CreateBill();
        },

        addDiscountRow: function () {

            var self = this;
            var index = self.disrows.length - 1;

            if ( self.rows.length == 1 ) {
                self.disrows[0].description_error_msg = "Please add invoice line item first";
                return;
            }
            self.disrows[index].description_error_msg = "";
            self.disrows[index].gl_account_error_msg = "";
            self.disrows[index].discount_error_msg = "";

            if ((self.disrows[index].description != null && self.disrows[index].description != "" && self.disrows[index].description.trim() != "") && ( self.disrows[index].discount != null && self.disrows[index].discount != "") && (self.disrows[index].gl_account_id != null && self.disrows[index].gl_account_id.value)) {
                self.disrows.push({
                    discount_id:0,
                    discount: 0,
                    description: "",
                    description_error_msg: "",
                    gl_account_id:null,
                    gl_account_error_msg:"",
                    discount_error_msg:"",
                });

            } else {

                if (self.disrows[index].description == null || self.disrows[index].description == "") {
                    self.disrows[index].description_error_msg = "Description is Required.";
                }
                if (self.disrows[index].gl_account_id == null || !self.disrows[index].gl_account_id.value) {
                    self.disrows[index].gl_account_error_msg = "GL Account is Required.";
                }
                if (self.disrows[index].discount == null || self.disrows[index].discount == "" ) {
                    self.disrows[index].discount_error_msg = "Amount Required.";
                }
            }
            if ( self.disrows.length > 1) {
                self.showTotalSummary = true;
            }
        },
        removeDiscountElement: function (index) {
            var self = this;
            if (self.disrows.length >= 1) {
                if (self.disrows[index].discount_id == 0) {
                    self.disrows.splice(index, 1);
                    self.calculateDiscount();

                } else {
                    if (confirm('Are you sure that you want to delete this Vendor Invoice Discount Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/discount-item/delete",
                            type: "POST",
                            data: {
                                'id': self.disrows[index].discount_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.disrows.splice(index, 1);
                                    self.calculateDiscount();
                                }

                                if (self.disrows.length == 0) {
                                    self.disrows.push({
                                        discount_id:0,
                                        discount: 0,
                                        description: "",
                                        description_error_msg: "",
                                        gl_account_id:null,
                                        gl_account_error_msg:"",
                                        discount_error_msg:"",
                                    });
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-item-delete');
                            },
                        });
                    }
                }
            }
            if ( self.disrows.length > 1) {
                self.showTotalSummary = true;
            }
        },
        showMoreLessContent() {
            var self = this;
            if (!self.showMoreLessFlag) {
                self.showMoreLessLabel = "Show Less"
                self.showMoreLessFlag = true;
                $("#vendor-invoice-line-items-tbl").removeClass("less-information");
            }else{
                self.showMoreLessLabel = "Show More"
                self.showMoreLessFlag = false;
                $("#vendor-invoice-line-items-tbl").addClass("less-information");
            }
        },

        onChargeSelect(event,index) {
            var self = this;
            if (self.chrows[index].charge_id != null && self.chrows[index].charge_id != "") {
                self.chrows[index].unit_price = self.chrows[index].charge_id.price;
            }else{
                self.chrows[index].unit_price = "";
            }
            self.chrows[index].quantity = 1;
            self.calculateChargeAmount('',index);
        },
        onPOSelect($event) {
            var self = this;
            if (self.po != null) {
                if (self.po.type != undefined) {
                    if (self.po.type == "item") {
                        self.vendor_inv_type = "item";
                    }else if (self.po.type == "sublet_po") {
                        self.vendor_inv_type = "sublet_po";
                    }else {
                        self.vendor_inv_type = "";
                    }
                }else{  
                    self.vendor_inv_type = "";
                }
            }else{
                self.vendor_inv_type = "";
            }
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/accounting/BillCreate.vue